<template>
  <form v-on:submit="save">

    <div class="card card-info card-tabs " v-show="isedit">
      <div class="card-header p-0 pt-1 pl-1">
        <ul class="nav nav-tabs" id="custom-tabs-four-tab" role="tablist">
          <li class="nav-item">
            <a class="nav-link" v-bind:class="activetab == 1 ? 'active': 'disabled'" data-toggle="pill" href="#custom-tabs-four-home" role="tab" aria-controls="custom-tabs-four-home" aria-selected="true">1. Configuration</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" v-bind:class="activetab == 2 ? 'active': 'disabled'" data-toggle="pill" href="#custom-tabs-four-profile" role="tab" aria-controls="custom-tabs-four-profile" aria-selected="false">2. Scheme of Studies</a>
          </li>
        </ul>
      </div>
      <div class="card-body">
        <div class="tab-content active" id="custom-tabs-four-tabContent">
          <div class="tab-pane fade active show" id="custom-tabs-four-home" role="tabpanel" aria-labelledby="custom-tabs-four-home-tab">
            <div class="row" v-if="activetab === 1" id="divConfiguration">
              <div class="col-md-4">
                <div class="form-group">
                  <label>Program</label>
                  <select class="form-control" v-model="data1.ProgramID" required="required">
                    <option value="" disabled="disabled">--Select Program--</option>
                    <option v-for="item in programs" v-bind:value="item.ProgramID">{{item.ProgramName}}</option>
                  </select>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>Session</label>
                  <select class="form-control" v-model="data1.SessionID" v-on:change="loadSections()" required="required">
                    <option value="" disabled="disabled">--Select Session--</option>
                    <option v-for="item in sessions" v-bind:value="item.SessionID">{{item.Name}}</option>
                  </select>
                </div>
              </div>
              <div class="col-md-4" v-if="data1.ProgramID != '' && data1.SessionID != '' ">
                <div class="form-group">
                  <label>Program Duration <span v-if="data1.IsAnnual == 'True'">(Total Years)</span> <span v-if="data1.IsAnnual == 'False'">(Total Semesters)</span> </label>
                  <select class="form-control" v-model="data1.Duration" required="required">
                    <option value="" disabled="disabled">--Select--</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6" v-if="data1.IsAnnual == 'False'">6</option>
                    <option value="7" v-if="data1.IsAnnual == 'False'">7</option>
                    <option value="8" v-if="data1.IsAnnual == 'False'">8</option>
                    <option value="9" v-if="data1.IsAnnual == 'False'">9</option>
                    <option value="10" v-if="data1.IsAnnual == 'False'">10</option>
                    <option value="11" v-if="data1.IsAnnual == 'False'">11</option>
                    <option value="12" v-if="data1.IsAnnual == 'False'">12</option>
                  </select>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>Grade Setup</label>
                  <select class="form-control" v-model="data1.GradeSetupID" required="required">
                    <option value="" disabled="disabled">--Select GradeSetup--</option>
                    <option v-for="item in gradesetup" v-bind:value="item.GradeSetupID">{{item.Title}}</option>
                  </select>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" id="customCheckbox2" v-model="data1.ComprehensiveExam" :value="true" name="exam">
                    <label for="customCheckbox2" class="custom-control-label">Comprehensive Exam</label>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" id="customCheckbox1" v-model="data1.Internship" :value="true" name="internship">
                    <label for="customCheckbox1" class="custom-control-label">Internship</label>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" id="customCheckbox3" v-model="data1.CommunityWork" :value="true" name="ComunityW">
                    <label for="customCheckbox3" class="custom-control-label">Community Work</label>
                  </div>
                </div>
              </div>


            </div>
            <div class="row" v-if="activetab == 2" id="divRoadMap">
              <div class="col-md-4">
                <label>Program: </label>
                <select class="form-control" required="required" disabled>
                  <option value="0" selected="selected">{{programs.find(x => x.ProgramID == data1.ProgramID).ProgramName}}</option>
                </select>
              </div>
              <div class="col-md-4" style="margin-bottom: 15px">
                <label>Session</label>
                <select class="form-control" disabled>
                  <option value="1" selected="selected">{{sessions.find(x => x.SessionID == data1.SessionID).Name}}</option>
                </select>
              </div>
              <div class="col-md-6" v-for="(item , ind) in roadmap">
                <div class="form-group" style="border-top: 3px solid #343a40;">
                  <h5 style="margin-top: 10px"><span v-if="data1.IsAnnual=='True'">Year</span> <span v-if="data1.IsAnnual == 'False'">Semester</span> {{item.Semester}}</h5>
                  <div class="table-responsive">
                    <table width="100%" class="table table-bordered table-sm table-striped table-color " style="font-size: 12px;">
                      <thead class="bg-info">
                        <tr>
                          <th width="10%" rowspan="2">Code</th>
                          <th rowspan="2">Course Name</th>
                          <th width="15%" colspan="3" style="text-align: center">Credit Hours</th>
                          <th width="70px" rowspan="2" style="text-align: center">Offer Course</th>
                          <th width="70px" rowspan="2" style="text-align: center">Action</th>
                        </tr>
                        <tr>
                          <th style="text-align: center">Theory</th>
                          <th style="text-align: center">Lab</th>
                          <th style="text-align: center">Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item2,index) in item.Child">
                          <td>{{item2.CourseCode}}</td>
                          <td>{{item2.CourseName}}</td>
                          <td style="text-align: center">{{item2.Theory}}</td>
                          <td style="text-align: center">{{item2.Lab}}</td>
                          <td style="text-align: center">{{item2.CreditHours}}</td>
                          <td style="text-align: center">
                            <input type="checkbox" v-model="item2.IsOffered" v-on:change="loadModal(item2.RoadMapChildID, item2.IsOffered)" />
                          </td>
                          <td style="text-align: center">
                            <button v-if="item2.DeleteAble" v-on:click="editRoadMap(item2, ind, index)" type="button" style="background-color: transparent; border: none;"><i class="fa fa-edit "></i></button>
                            <button v-if="item2.DeleteAble" v-on:click="removeRoadMapCourse(item2, ind, index)" type="button" style="background-color: transparent; border: none;"><i class="fa fa-trash "></i></button>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colspan="7">
                            <button class="btn btn-dark btn-sm btn-block" type="button" v-on:click="Add(item.Semester)">Add Course</button>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="7">
                            <span>Total Courses: {{totalCourses(ind)}}</span>
                            <span class="pull-right">Total Credit Hour: {{totalCreditHours(ind)}}</span>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div style="border-top: 3px solid #605ca8; margin-top: 20px">
                  <h4>Total Summary</h4>
                  <div class="table-responsive">
                    <table width="100%" class="table table-bordered table-sm  table-striped table-color">
                      <thead class="bg-info">
                        <tr>
                          <th>Types</th>
                          <th>Total Number of Courses</th>
                          <th>Total Number of Credit Hours</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="check(item.CourseTypeID)" v-for="item,index in coursetype">
                          <td>{{item.Name}}</td>
                          <td>{{convertsss(item.CourseTypeID)}}</td>
                          <td>{{convertsss2(item.CourseTypeID)}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card-footer">

        <button class="btn btn-primary pull-left" type="button" v-on:click="backClick()" v-if="activetab > 1">Back</button>
        <button class="btn btn-success float-right" data-toggle="modal" data-target="#myModal" type="button" v-if="activetab == 1 && ((data1.IsAnnual != copy.IsAnnual || data1.Duration != copy.Duration || data1.IsOBE != copy.IsOBE)) ">Save and Next</button>
        <button class="btn btn-success float-right" v-else-if="activetab == 1" type="submit">Save and Next</button>
        <button class="btn btn-danger" type="button" v-on:click="cancel()">Cancel</button>

      </div>
      <!-- /.card -->
    </div>

    <div class="card card-info" v-show="!isedit">
      <div class="card-header with-border">
        <h3 style="width: 100%" class="card-title info">
          Program - Session Configuration
          <button type="button" v-on:click="edit(0)" class=" float-right btn btn-sm btn-outline-secondary btn-default"><i class="fa fa-plus"> Add New</i></button>
        </h3>
      </div>
      <!-- /.box-header -->
      <!-- form start -->
      <div class="card-body">
        <div class="row" style="padding-bottom: 1%; padding-top: 1%;">
          <div class="col-md-12">
            <div class="table-responsive">
              <table class="table table-bordered table-sm table-color" id="bs4-table">
                <thead class="bg-info">
                  <tr>
                    <th>Program</th>
                    <th>Session</th>
                    <th>Road Map</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in records">
                    <td>{{item.ProgramName}}</td>
                    <td>{{item.SessionName}}</td>
                    <td>{{item.RoadMap}}</td>
                    <td>
                      <i class="fa fa-2x fa-edit" v-on:click="edit(item.ID)"></i>
                      <i v-if="item.RoadMap == 'Created'" class="fa fa-2x fa-print" v-on:click="print(item.RoadMapID)"></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="myModal" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header bg-info">
            <h3 style="color: white" class="modal-title">Note!</h3>
          </div>
          <div class="modal-body">
            <ul>
              <li v-if="data1.IsAnnual != copy.IsAnnual">You change 'Final System' which will delete <b>Fee Structure</b></li>
              <li v-if="data1.Duration != copy.Duration">If you change 'Program Duration' which will delete <b>Fee Structure</b> and <b>Road Map</b></li>
              <li v-if="data1.IsOBE != copy.IsOBE">You change 'Outcome Base Education' which will delete <b>Road Map</b></li>
              <li v-if="data1.FeeStyle != copy.FeeStyle">You change 'Fee Style' which will delete <b>Fee Structure</b></li>
            </ul>
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn btn-success">Continue</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Delete-->
    <div class="modal fade" id="mdlDelete" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header bg-info">
            <h3 style="color: white" class="modal-title">Confirmation!</h3>
          </div>
          <div class="modal-body text-center">
            <h4>Are you sure you want to delete this?</h4>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" v-on:click="deleteRoadMapCourse()">Delete</button>
            <button type="button" class="btn btn-danger" data-dismiss="modal">Cancel</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal Offer course -->
    <div class="modal fade" id="offercourseDelete" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header bg-info">
            <h3 style="color: white" class="modal-title">Confirmation!</h3>
          </div>
          <div class="modal-body text-center">
            <h3>Do you want to ?</h3>
            <div class="checkbox">
              <label>
                <input type="checkbox" v-model="delstandteachers" />
                Delete Enrolled Students and Teachers
              </label>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" v-on:click="courseOfferChange(childID)">Continue</button>
            <button type="button" class="btn btn-danger" data-dismiss="modal">Cancel</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Road Map -->
    <div class="modal fade" id="mdlRoadMap" role="dialog">
      <div class="modal-dialog  modal-lg">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header bg-info">
            <h3 style="color: white" class="modal-title"><span v-if="data1.IsAnnual=='True'">Year</span> <span v-if="data1.IsAnnual == 'False'">Semester</span> {{rm.Semester}} </h3>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>Course</label>
                  <v-select v-model="alt" v-bind:multiple="false" v-bind:options="course" label="Data" style="max-width: 100%;" transition="" v-on:input="selectedCourseChange()"></v-select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>Course Type</label>
                  <select class="form-control" v-model="rm.CourseTypeID">
                    <option value="0">--Select Type--</option>
                    <option v-for="item in coursetype" v-bind:value="item.CourseTypeID">{{item.Name}}</option>
                  </select>
                </div>
              </div>

              <div class="col-md-6" v-if="data1.IsOBE == 'True'">
                <div class="form-group">
                  <label>Knowledge Area</label>
                  <select class="form-control" v-model="rm.KnwoledgeAreaID">
                    <option value="0">--Select Know. Area--</option>
                    <option v-for="item in knowledgeArea" v-bind:value="item.CourseKnowledgeAreaID">{{item.Name}}</option>
                  </select>
                </div>
              </div>

              <div class="col-md-6" v-if="data1.IsOBE == 'True'">
                <div class="form-group">
                  <label>Course Domain</label>
                  <select class="form-control" v-model="rm.DomainID">
                    <option value="0">--Select Domain--</option>
                    <option v-for="item in domain" v-bind:value="item.CourseDomainID">{{item.Name}} - ({{item.Digit}})</option>
                  </select>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label>Credit Hours</label>
                  <div class="row">
                    <div class="col-md-6">
                      <input class="form-control" placeholder="Theory" v-model.number="rm.Theory" />
                    </div>
                    <div class="col-md-6">
                      <input class="form-control" placeholder="Lab" v-model.number="rm.Lab" />
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label>Cr. Hour Description</label>
                  <input class="form-control" v-model="rm.Description" />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-success" v-on:click="saveRoadMap()">Save</button>
            <button type="button" class="btn btn-danger" data-dismiss="modal">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
  const axios = require('axios').default;
  export default ({
    data() {
      return {
        childID: 0,
        delstandteachers: false,
        records: [],
        copy: { ProgramID: '', SessionID: '', SectionID: '0', IsAnnual: 'False', IsOBE: 'False', FeeStyle: '', Duration: '' },
        data1: { ProgramID: '', SessionID: '', GradeSetupID: '', SectionID: '0', IsAnnual: 'False', IsOBE: 'False', FeeStyle: '', Duration: '', ComprehensiveExam: false },
        data2: {},
        isedit: false,
        programs: [],
        sessions: [],
        gradesetup: [],
        sections: [],
        feeheads: [],
        activetab: 1,
        selectedemp: [],
        feetype: [],
        feegrandtotal: 0,
        date: '',
        feescheme: [],
        feeexceptional: [],
        sameforall: true,
        width: '100%',
        semester: 0,
        coursetypeID: 0,
        knowledgeArea: [],
        domain: [],
        course: [], coursetype: [],

        rm: {
          Semester: '', CourseCode: '', CourseID: 0, CourseTypeID: 0, Theory: '', Lab: '',
          Description: '', KnwoledgeAreaID: 0, KnowledgeAreaBindingID: 0, DomainID: 0,
        },

        semesters: [], pre: [], pres: 0, pres2: 0,
        roadmap: [],
        roadmapid: 0,
        rmIndex: - 1,
        crsIndex: - 1,
        previousRoadMaps: [],
        deleteCourse: null,

        alt: '',
      }
    },
    created: function () {
      this.loadRecord();
    },
    updated: function () {
      $('#bs4-table').DataTable();
    },
    methods: {

      check(ID) {
        var count = 0;
        var vm = this;
        this.roadmap.forEach(function (r) {
          if (r.Child != null && r.Child != '') {
            r.Child.forEach(function (c) {
              if (c.CourseTypeID == ID) {
                count = count + 1;
              }
            })
          }
        })
        if (count == 0)
          return false;
        else
          return true;
      },

      //count courses type wise
      convertsss(ID) {
        var count = 0;
        var vm = this;
        this.roadmap.forEach(function (r) {
          if (r.Child != null && r.Child != '') {
            r.Child.forEach(function (c) {
              if (c.CourseTypeID == ID) {
                count = count + 1;
              }
            })
          }
        })

        return count;
      },

      //count creidt hours type wise
      convertsss2(ID) {
        var count = 0;
        this.roadmap.forEach(function (r) {
          if (r.Child != null && r.Child != '') {
            r.Child.forEach(function (c) {
              if (c.CourseTypeID == ID) {
                count = count + Number(c.CreditHours);
              }
            })
          }
        })

        return count;
      },

      loadRecord() {
        var vm = this;
        startReq();
        axios.post('/api/DCApi/loadRecord')
          .then(function (response) {
            vm.records = response.data.lst;
            vm.gradesetup = response.data.gradesetup;
            endReq();
          })
      },

      courseOfferChange(id) {
        startReq();
        var vm = this;
        axios.post('/api/DCApi/saveCoursesOffered?crsID=' + id + '&delst=' + vm.delstandteachers)
          .then(function (res) {
            endReq();
            if (res.data.status) {
              toastr.success(res.data.masg);
              $('#offercourseDelete').modal('hide');
              this.delstandteachers = true;
            }
            else {
              toastr.error(res.data.masg1);
            }

          })
          .then(function (error) {
            console.log(error)
          })
      },

      selectedCourseChange() {
        this.rm.CourseID = this.alt.Course_SubjectID;
        this.rm.CourseCode = this.alt.Code;
        this.rm.CourseName = this.alt.Name;
      },

      loadrecord3() {
        var vm = this;
        axios.post('/api/DCApi/checkRoadMap2', {
          data: vm.data1,
          SessionID: vm.pres2
        })
          .then(function (res) {
            var result = res.data.replace('{"d":null}', '');
            var rs = JSON.parse(result);
            if (rs != "false") {

              vm.semesters = rs.roadmap;
              vm.KPI = rs.KPI;

            }
            else {
              vm.semesters = [];
              vm.KPI = '';
            }

          })

      },

      backClick() {
        this.activetab = Number(this.activetab) - 1;
      },
      loadModal(RoadMapChildID, IsOffered) {
        if (IsOffered == true) {
          this.courseOfferChange(RoadMapChildID);
        }
        else {
          $('#offercourseDelete').modal('show');
          this.childID = RoadMapChildID;
        }
      },

      loadSections() {
        var vm = this;
        startReq();
        axios.post('/api/DCApi/loadSections?progID=' + vm.data1.ProgramID + '&sesID=' + vm.data1.SessionID)
          .then(function (response) {
            vm.sections = response.data.record;
            endReq();
          })
      },

      cancel() {
        location.reload();
      },

      editRoadMap(item, ind, index) {
        startReq();
        var vm = this;

        vm.rmIndex = ind;
        vm.crsIndex = index;
        vm.alt = vm.course.find(x => x.Course_SubjectID == item.CourseID);
        vm.rm = {
          Semester: item.Semester, CourseCode: item.CourseCode, CourseID: item.CourseID, CourseTypeID: item.CourseTypeID,
          Theory: item.Theory, Lab: item.Lab, Description: item.Description, KnwoledgeAreaID: item.KnwoledgeAreaID,
          DomainID: item.DomainID, RoadMapChildID: item.RoadMapChildID, RoadMapMasterID: item.RoadMapMasterID
        };
        endReq();
        $('#mdlRoadMap').modal('show');
      },

      save(e) {
        e.preventDefault();
        if (this.activetab == 1) {
          startReq();
          var vm = this;
          $('#myModal').modal('hide');
          axios.post('/api/DCApi/saveTab1', {
            obj: vm.data1
          })
            .then(function (res) {
              vm.pre = res.data.exs;
              if (res.data.status) {
                axios.post('/api/DCApi/loadRoadMap', {
                  obj: vm.data1
                })
                  .then(function (r) {
                    vm.coursetype = r.data.typ;
                    vm.course = r.data.crs;
                    vm.roadmap = r.data.child;
                    vm.knowledgeArea = r.data.kno;
                    vm.roadmapid = r.data.rmID;
                    vm.previousRoadMaps = r.data.exs;
                    vm.domain = r.data.dom;
                    endReq();
                    vm.activetab = 2;
                  })
                  .then(function (error) {
                    console.log(error)
                  })
              }
              else {
                toastr.error(res.data.masg);
                endReq();
              }
            })
        }

      },

      edit(id) {
        startReq();
        var vm = this;
        axios.post('/api/DCApi/pageLoad?id=' + id)
          .then(function (response) {
            vm.programs = response.data["prog"];
            vm.sessions = response.data["ses"];

            if (id != "0") {

              vm.copy.IsAnnual = response.data["data"].IsAnnual;
              vm.copy.IsOBE = response.data["data"].IsOBE;
              vm.copy.Duration = response.data["data"].Duration;
              vm.copy.FeeStyle = response.data["data"].FeeStyle;

              axios.post('/api/DCApi/loadSections?progID=' + response.data["data"].ProgramID + '&sesID=' + response.data["data"].SessionID)
                .then(function (re) {
                  vm.sections = re.data;
                  vm.data1 = response.data["data"];
                })
            }
            vm.activetab = 1;
            endReq();
          })
        vm.isedit = true;
      },

      print(id) {
        axios.post('/api/DCApi/printBatchConfig?id=' + id)
          .then(function (res) {
            if (res.data.status) {
              window.open(res.data.url, '_blank');
            }
          })
      },

      removeRoadMapCourse(item, ind, index) {
        this.deleteCourse = { item, ind, index };
        $('#mdlDelete').modal('show');
      },

      deleteRoadMapCourse() {
        startReq();
        var vm = this;
        axios.post('/api/DCApi/removeRoadMapCourse', {
          rm: vm.deleteCourse.item
        })
          .then(function (res) {
            endReq();
            if (res.data.status) {
              vm.roadmap[vm.deleteCourse.ind].Child.splice(vm.deleteCourse.index, 1);
              toastr.success("Deleted Successfully", "Done!");
              $('#mdlDelete').modal('hide');
            }
            else {
              toastr.error(res.data.msg, "Error!");
            }
          })
      },

      totalCourses(sem) {
        if (this.roadmap[sem].Child != null && this.roadmap[sem].Child != '')
          return this.roadmap[sem].Child.length;
        else
          return 0;
      },

      saveRoadMap() {

        if (this.alt == null || this.alt == "") {
          toastr.error("Course is required", "Error");
          return;
        }
        if (this.rm.CourseTypeID == 0) {
          toastr.error("Course Type is required", "Error");
          return;
        }
        if (this.rm.Theory == 0 && this.rm.Lab == 0) {
          toastr.error("Credit hour is required", "Error");
          return;
        }
        else {
          if (this.rm.Theory == '')
            this.rm.Theory = 0;
          if (this.rm.Lab == '')
            this.rm.Lab = 0;
        }
        if (this.rm.KnowledgeAreaID == 0) {
          toastr.error("Knowledge Area is required", "Error");
          return;
        }
        if (this.data1.IsOBE == 'True' && this.rm.DomainID == 0) {
          toastr.error("Course Domain is required", "Error");
          return;
        }

        startReq();
        var vm = this;
        axios.post('/api/DCApi/saveRoadMap?rmID=' + vm.roadmapid, {
          rm: vm.rm,
          obj: vm.data1,
        })
          .then(function (res) {
            endReq();
            if (!res.data.status) {
              toastr.error(res.data.msg, "Error!");
              return;
            }

            var item = res.data.rm;
            vm.roadmapid = item.RoadMapMasterID;
            vm.alt = null;

            if (vm.rm.RoadMapChildID == 0) {

              if (vm.roadmap[vm.rmIndex].Child == null || vm.roadmap[vm.rmIndex].Child == '') {
                vm.roadmap[vm.rmIndex].Child = [];
              }

              vm.roadmap[vm.rmIndex].Child.push({
                Semester: item.Semester, CourseCode: item.CourseCode, CourseName: item.CourseName, CourseID: item.CourseID, CourseTypeID: item.CourseTypeID,
                Theory: item.Theory, Lab: item.Lab, CreditHours: item.CreditHours, Description: item.Description, KnwoledgeAreaID: item.KnwoledgeAreaID,
                DomainID: item.DomainID, RoadMapChildID: item.RoadMapChildID,
                RoadMapMasterID: item.RoadMapMasterID, DeleteAble: true
              });

            }
            else {
              var it = vm.roadmap[vm.rmIndex].Child[vm.crsIndex];
              it.Semester = item.Semester; it.CourseCode = item.CourseCode; it.CourseName = item.CourseName; it.CourseID = item.CourseID; it.CourseTypeID = item.CourseTypeID;
              it.Theory = item.Theory; it.Lab = item.Lab; it.CreditHours = item.CreditHours; it.Description = item.Description; it.KnwoledgeAreaID = item.KnwoledgeAreaID;
              it.DomainID = item.DomainID; it.RoadMapChildID = item.RoadMapChildID;
              it.RoadMapMasterID = item.RoadMapMasterID;
            }

            vm.rm = {
              Semester: item.Semester, CourseCode: '', CourseID: 0, CourseTypeID: 0, Theory: 0, Lab: 0, Description: '',
              KnwoledgeAreaID: 0, KnowledgeAreaBindingID: 0, DomainID: 0, RoadMapChildID: 0, RoadMapMasterID: 0
            };

            vm.alt = null;

            toastr.success("Saved Successfully", "Done!");
          })
      },

      totalCreditHours(sem) {
        var cr = 0;
        var vm = this;
        if (vm.roadmap[sem].Child != null && vm.roadmap[sem].Child != '') {
          vm.roadmap[sem].Child.forEach(function (item) {
            cr += Number(item.CreditHours);
          });
          return cr;
        }
        else
          return 0;
      },

      Add(sem) {
        this.rmIndex = sem - 1;
        this.rm = {
          Semester: sem, CourseCode: '', CourseID: 0, CourseTypeID: 0, Theory: 0, Lab: 0, Description: '',
          KnwoledgeAreaID: 0, KnowledgeAreaBindingID: 0, DomainID: 0, RoadMapChildID: 0, RoadMapMasterID: 0
        };
        this.alt = null;

        $('#mdlRoadMap').modal('show');
      },

    }
  })</script>

<style>
  .txtNumber {
    text-align: right;
  }

  .focus {
    background-color: #ddd;
    color: #fff;
    cursor: pointer;
    font-weight: bold;
  }

  table {
    font-family: arial, sans-serif;
    border-collapse: collapse;
    width: 100%;
  }

  td,
  th {
    border: 1px solid #dddddd;
    text-align: left;
    padding: 8px;
  }

  td {
    vertical-align: middle !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/DC/batchConfig.vue